import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Copy, CheckCircle, Mail, Download, Building2, GraduationCap, Landmark, Users, ExternalLink, Phone } from "lucide-react";
import { Button } from "../components/ui/button";
import { InternalNav } from "../components/InternalNav";

// REGIONE TOSCANA
const regioneToscana = [
  {
    name: "Sviluppo Toscana - Innovazione Digitale",
    type: "Ente Regionale",
    email: "innovazione@sviluppo.toscana.it",
    phone: "055 2657550",
    website: "sviluppo.toscana.it/impresa_digitale2025",
    note: "Bando Impresa Digitale 2025 - fino 70% fondo perduto"
  },
  {
    name: "Sviluppo Toscana - Supporto Tecnico",
    type: "Ente Regionale",
    email: "supportoinnovazione@sviluppo.toscana.it",
    phone: "055 2657550",
    website: "sft.sviluppo.toscana.it",
    note: "Supporto informatico piattaforma SFT"
  },
  {
    name: "Regione Toscana - Formazione",
    type: "Settore Regionale",
    email: "-",
    phone: "-",
    website: "regione.toscana.it/formazione",
    note: "Bandi GOL, Voucher formativi, Upskilling PNRR"
  },
  {
    name: "Punti Digitale Facile (PNRR 1.7.2)",
    type: "Programma PNRR",
    email: "-",
    phone: "-",
    website: "regione.toscana.it/-/punti-digitale-facile",
    note: "5 milioni € - Scadenza 30/09/2025"
  }
];

// FONDAZIONI
const fondazioni = [
  {
    name: "Fondazione CR Firenze",
    type: "Fondazione Bancaria",
    email: "info@fondazionecrfirenze.it",
    phone: "+39 055 5384001",
    address: "Via Maurizio Bufalini 6, 50122 Firenze",
    website: "fondazionecrfirenze.it",
    bando: "Bando Digitale Sociale - 1,5 milioni €",
    note: "Empowerment digitale non-profit"
  },
  {
    name: "Fondazione Monte dei Paschi Siena",
    type: "Fondazione Bancaria",
    email: "fmps@fondazionemps.it",
    phone: "0577 246030",
    address: "Via Banchi di Sotto 34, 53100 Siena",
    website: "fondazionemps.it",
    bando: "IKIGAI - Borse fino 6.000€",
    note: "Under 35 Siena/Grosseto/Arezzo"
  },
  {
    name: "Fondazione MPS - Let's Digital",
    type: "Programma",
    email: "fmps@fondazionemps.it",
    phone: "0577 246030",
    website: "fondazionemps.it",
    bando: "Voucher 500€ iniziative digitali",
    note: "50.000€ totali disponibili"
  }
];

// SCUOLE PNRR DM 66
const scuole = [
  {
    name: "IIS Sociali Siena",
    type: "Scuola Statale",
    progetto: "DIGITAL@MENTE (M4C1I2.1-2023-1222-P-33114)",
    website: "isisociali.edu.it",
    note: "Cercano tutor/formatori transizione digitale"
  },
  {
    name: "Scuola Futura Toscana",
    type: "Portale Regionale",
    website: "scuolafutura.toscana.it",
    note: "Gestisce riparto DM 66 - Animatori digitali"
  },
  {
    name: "USR Toscana",
    type: "Ufficio Scolastico Regionale",
    website: "istruzionetoscana.it",
    email: "direzione-toscana@istruzione.it",
    note: "Coordina PNRR scuole Toscana"
  }
];

// EMAIL AGGRESSIVA ENTI
const emailEnti = `OGGETTO: Proposta Formazione Digitale Certificata Google - Deducibile 100% | PNRR/DM 66

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Spett.le [*NOME ENTE / FONDAZIONE / SCUOLA*],
alla c.a. [*RESPONSABILE FORMAZIONE / DIRIGENTE*]

Sono Riccardo Rossi, Fotografo Google Street View Certificato dal 2016.

NON sono un docente. Sono un professionista con:
• 7.000+ foto pubblicate su Google Maps
• 52 MILIONI di visualizzazioni certificate
• 9 anni di esperienza sul campo

Potrei essere definito un "influencer silente su Google" - senza canali social, senza balletti, solo risultati misurabili.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

📊 IL CONTESTO (Dati 2024-2025)

• Mercato e-Learning Italia: 3 MILIARDI €
• Formazione aziendale: 1,5 MILIARDI €
• Mismatch competenze digitali: COSTA 44 MILIARDI €/anno
• Partecipazione adulti formazione: 9,6% (SOTTO target UE)

La domanda c'è. È latente. Aspetta solo di essere attivata.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

🎯 LA MIA PROPOSTA

FORMAZIONE PRATICA "Google Street View Trusted"
Formo i vostri studenti/dipendenti/iscritti a diventare il "Riccardo di domani":

✓ Come diventare Fotografo Google Certificato
✓ Virtual Tour 360° con GoPro MAX (5.6K, 16.6MP)
✓ Pubblicazione su Google Maps
✓ Monetizzazione delle competenze acquisite

VIRTUAL TOUR 360° PER LA VOSTRA SEDE
Mostrate i vostri spazi ai cittadini/studenti/clienti con tour immersivi.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

💰 VANTAGGI ECONOMICI (IL PUNTO CHIAVE)

┌─────────────────────────────────────────────┐
│  DEDUCIBILE 100%                            │
│  come spesa pubblicitaria/formazione        │
│  (Art. 108 TUIR)                            │
│                                             │
│  TAEG 0% - PayPal 3 rate                    │
│  Senza interessi, senza sorprese            │
│                                             │
│  COMPATIBILE PNRR DM 66                     │
│  Formazione transizione digitale            │
│  Compenso formatori: €122/ora lordo         │
└─────────────────────────────────────────────┘

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

📦 PACCHETTI PER ENTI

| Pacchetto | Contenuto | Investimento |
|-----------|-----------|--------------|
| FORMAZIONE BASE | 8 ore + materiali | €980 |
| FORMAZIONE + TOUR | 8 ore + 2 Virtual Tour | €1.499 |
| PACCHETTO SCUOLA | 16 ore + certificazione | €1.899 |
| CONVENZIONE ANNUALE | Illimitato per iscritti | Su misura |

Tutti i pacchetti: Deducibili 100% • PayPal 3 rate • TAEG 0%

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

🎁 PER VOI, OGGI

Se rispondete entro [*DATA*], offro:
• 1 Virtual Tour della vostra sede IN REGALO
• Presentazione gratuita ai vostri iscritti/studenti
• Materiale didattico personalizzato

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

🔗 DEMO LIVE

Esplorate i miei lavori:
→ https://schedabusiness.it
→ https://schedabusiness.com

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

📞 CONTATTATEMI

Riccardo Rossi
Fotografo Google Street View Certificato dal 2016

📱 WhatsApp: +39 327 383 9782
📧 [*LA TUA EMAIL*]
🌐 schedabusiness.it

Non sono un bot. Non sono un'AI.
Sono io, in carne ed ossa.
Fissiamo una call?

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

[*FIRMA / BADGE GOOGLE CERTIFIED*]

P.S. Il mercato della formazione digitale vale 3 miliardi.
Il mismatch di competenze costa 44 miliardi all'anno.
Voi potete essere parte della soluzione.
Io posso aiutarvi.`;

// EMAIL SCUOLE PNRR
const emailScuole = `OGGETTO: Candidatura Formatore Esterno - Transizione Digitale DM 66/2023 | Google Street View Certified

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Spett.le Dirigente Scolastico,
Spett.le Animatore Digitale,

mi permetto di proporre la mia candidatura come FORMATORE ESTERNO per i percorsi di transizione digitale previsti dal DM 66/2023 (PNRR Missione 4, Componente 1, Investimento 2.1).

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

👤 CHI SONO

Riccardo Rossi
Fotografo Google Street View CERTIFICATO dal 2016

Credenziali verificabili:
• 7.000+ foto pubblicate su Google Maps
• 52.000.000 visualizzazioni certificate
• 9 anni di attività professionale continuativa

NON sono un docente tradizionale.
Sono un PROFESSIONISTA DEL DIGITALE con risultati misurabili.

Per i vostri studenti, potrei essere l'equivalente di un "influencer su Google" - ma senza social, senza balletti. Solo competenze concrete e monetizzabili.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

📚 PROPOSTA FORMATIVA

MODULO: "Diventa il Google Photographer di domani"

Competenze DigComp 2.2 / DigCompEdu coperte:
• Area 1: Alfabetizzazione digitale
• Area 2: Comunicazione e collaborazione
• Area 3: Creazione di contenuti digitali
• Area 5: Problem solving

Contenuti pratici:
1. Come diventare Fotografo Google Certificato
2. Tecniche di ripresa 360° (GoPro MAX)
3. Post-produzione e pubblicazione
4. Monetizzazione delle competenze
5. Personal branding professionale

Durata: 8-16 ore (modulabile)
Modalità: Presenza / Online / Ibrida
Gruppo: Min 15 corsisti (come da linee guida)

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

💰 ASPETTI ECONOMICI

Compenso richiesto: In linea con DM 66
(€122/ora lordo stato per formazione PNRR)

Disponibilità: Immediata
Fatturazione: Regolare con P.IVA

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

🎁 VALORE AGGIUNTO

• Attrezzatura professionale inclusa (GoPro MAX 360°)
• Materiale didattico personalizzato
• Virtual Tour della scuola IN REGALO (valore €499)
• Certificato di partecipazione per studenti

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

📞 CONTATTI

Riccardo Rossi
📱 +39 327 383 9782
📧 [*EMAIL*]
🌐 schedabusiness.it

Resto a disposizione per un colloquio conoscitivo.

Cordiali saluti,
Riccardo Rossi
Google Street View Trusted Photographer`;

export default function StrategiaEnti() {
  const navigate = useNavigate();
  const [copiedEmail, setCopiedEmail] = useState(null);
  const [activeTab, setActiveTab] = useState("regione");

  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopiedEmail(id);
    setTimeout(() => setCopiedEmail(null), 3000);
  };

  const tabs = [
    { id: "regione", label: "Regione Toscana", icon: Landmark },
    { id: "fondazioni", label: "Fondazioni", icon: Building2 },
    { id: "scuole", label: "Scuole PNRR", icon: GraduationCap },
    { id: "email", label: "Email Enti", icon: Mail },
  ];

  return (
    <div className="min-h-screen bg-[#F8F9FA] py-8 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-[#5F6368] hover:text-[#202124] mb-6"
          >
            <ArrowLeft className="w-4 h-4" />
            Torna alla Home
          </button>

          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <span className="px-3 py-1 rounded-full bg-[#EA4335] text-white text-xs font-medium">
                STRATEGIA AGGRESSIVA
              </span>
              <span className="px-3 py-1 rounded-full bg-[#34A853] text-white text-xs font-medium">
                DEDUCIBILE 100%
              </span>
            </div>
            <h1 className="text-3xl sm:text-4xl font-semibold text-[#202124] mb-2">
              Enti Pubblici & Fondazioni
            </h1>
            <p className="text-[#5F6368]">
              Mercato formazione: <strong>3 miliardi €</strong> | Mismatch competenze: <strong>44 miliardi €/anno</strong> | PNRR DM 66: <strong>€122/ora</strong>
            </p>
          </div>

          {/* Tabs */}
          <div className="flex flex-wrap gap-2 mb-6 bg-white p-2 rounded-2xl border border-[#DADCE0]">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-all ${
                  activeTab === tab.id 
                    ? "bg-[#4285F4] text-white" 
                    : "text-[#5F6368] hover:bg-[#F8F9FA]"
                }`}
              >
                <tab.icon className="w-4 h-4" />
                {tab.label}
              </button>
            ))}
          </div>

          {/* REGIONE TOSCANA */}
          {activeTab === "regione" && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <div className="grid gap-4">
                {regioneToscana.map((ente, i) => (
                  <div key={i} className="p-5 rounded-2xl bg-white border border-[#DADCE0] hover:shadow-md transition-all">
                    <div className="flex items-start justify-between">
                      <div>
                        <div className="flex items-center gap-2 mb-1">
                          <Landmark className="w-5 h-5 text-[#4285F4]" />
                          <h3 className="font-semibold text-[#202124]">{ente.name}</h3>
                        </div>
                        <p className="text-xs text-[#4285F4] font-medium mb-2">{ente.type}</p>
                        <p className="text-sm text-[#5F6368] mb-3">{ente.note}</p>
                        <div className="flex flex-wrap gap-2">
                          {ente.email && ente.email !== "-" && (
                            <button
                              onClick={() => copyToClipboard(ente.email, ente.email)}
                              className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#F8F9FA] text-xs hover:bg-[#E8F0FE]"
                            >
                              {copiedEmail === ente.email ? <CheckCircle className="w-3 h-3 text-[#34A853]" /> : <Mail className="w-3 h-3" />}
                              {ente.email}
                            </button>
                          )}
                          {ente.phone && ente.phone !== "-" && (
                            <a href={`tel:${ente.phone}`} className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#F8F9FA] text-xs hover:bg-[#E6F4EA]">
                              <Phone className="w-3 h-3" /> {ente.phone}
                            </a>
                          )}
                        </div>
                      </div>
                      <a href={`https://${ente.website}`} target="_blank" rel="noopener noreferrer" className="p-2 hover:bg-[#F8F9FA] rounded-full">
                        <ExternalLink className="w-4 h-4 text-[#5F6368]" />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          )}

          {/* FONDAZIONI */}
          {activeTab === "fondazioni" && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <div className="grid md:grid-cols-2 gap-4">
                {fondazioni.map((fond, i) => (
                  <div key={i} className="p-5 rounded-2xl bg-gradient-to-br from-[#FEF7E0] to-white border border-[#FBBC05]/30 hover:shadow-lg transition-all">
                    <div className="flex items-center gap-2 mb-2">
                      <Building2 className="w-5 h-5 text-[#FBBC05]" />
                      <h3 className="font-semibold text-[#202124]">{fond.name}</h3>
                    </div>
                    <p className="text-xs text-[#FBBC05] font-medium mb-1">{fond.type}</p>
                    {fond.bando && <p className="text-sm font-semibold text-[#202124] mb-1">{fond.bando}</p>}
                    <p className="text-sm text-[#5F6368] mb-3">{fond.note}</p>
                    {fond.address && <p className="text-xs text-[#5F6368] mb-3">📍 {fond.address}</p>}
                    <div className="flex flex-wrap gap-2">
                      <button
                        onClick={() => copyToClipboard(fond.email, fond.email)}
                        className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/80 text-xs hover:bg-[#E8F0FE]"
                      >
                        {copiedEmail === fond.email ? <CheckCircle className="w-3 h-3 text-[#34A853]" /> : <Mail className="w-3 h-3" />}
                        {fond.email}
                      </button>
                      <a href={`tel:${fond.phone}`} className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/80 text-xs hover:bg-[#E6F4EA]">
                        <Phone className="w-3 h-3" /> {fond.phone}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          )}

          {/* SCUOLE */}
          {activeTab === "scuole" && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <div className="p-4 rounded-xl bg-[#E8F0FE] border border-[#4285F4]/20 mb-6">
                <h3 className="font-semibold text-[#202124] mb-2">💡 PNRR DM 66/2023 - Opportunità</h3>
                <ul className="text-sm text-[#5F6368] space-y-1">
                  <li>• <strong>450 milioni €</strong> per formazione digitale scuole</li>
                  <li>• Compenso formatori: <strong>€122/ora lordo</strong></li>
                  <li>• Le scuole CERCANO formatori esterni esperti digitale</li>
                  <li>• Puoi proporti come "Google Street View Expert"</li>
                </ul>
              </div>
              <div className="grid gap-4">
                {scuole.map((scuola, i) => (
                  <div key={i} className="p-5 rounded-2xl bg-white border border-[#DADCE0] hover:shadow-md">
                    <div className="flex items-center gap-2 mb-2">
                      <GraduationCap className="w-5 h-5 text-[#34A853]" />
                      <h3 className="font-semibold text-[#202124]">{scuola.name}</h3>
                    </div>
                    <p className="text-xs text-[#34A853] font-medium mb-1">{scuola.type}</p>
                    {scuola.progetto && <p className="text-sm font-medium text-[#202124] mb-1">{scuola.progetto}</p>}
                    <p className="text-sm text-[#5F6368] mb-3">{scuola.note}</p>
                    <div className="flex flex-wrap gap-2">
                      {scuola.email && (
                        <button
                          onClick={() => copyToClipboard(scuola.email, scuola.email)}
                          className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#F8F9FA] text-xs hover:bg-[#E8F0FE]"
                        >
                          {copiedEmail === scuola.email ? <CheckCircle className="w-3 h-3 text-[#34A853]" /> : <Mail className="w-3 h-3" />}
                          {scuola.email}
                        </button>
                      )}
                      <a href={`https://${scuola.website}`} target="_blank" rel="noopener noreferrer" 
                        className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#F8F9FA] text-xs hover:bg-[#E6F4EA]">
                        <ExternalLink className="w-3 h-3" /> {scuola.website}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          )}

          {/* EMAIL TEMPLATES */}
          {activeTab === "email" && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
              {/* Email Enti */}
              <div className="bg-white rounded-2xl border border-[#DADCE0] overflow-hidden">
                <div className="bg-[#EA4335] px-6 py-3 flex items-center justify-between">
                  <span className="text-white font-medium">📧 Email Enti Pubblici & Fondazioni</span>
                  <Button
                    size="sm"
                    className={`${copiedEmail === 'enti' ? 'bg-[#34A853]' : 'bg-white text-[#EA4335]'} rounded-full`}
                    onClick={() => copyToClipboard(emailEnti, 'enti')}
                  >
                    {copiedEmail === 'enti' ? <CheckCircle className="w-4 h-4 mr-1" /> : <Copy className="w-4 h-4 mr-1" />}
                    {copiedEmail === 'enti' ? 'Copiato!' : 'Copia'}
                  </Button>
                </div>
                <pre className="p-6 text-sm text-[#202124] whitespace-pre-wrap font-mono leading-relaxed max-h-96 overflow-y-auto">
                  {emailEnti}
                </pre>
              </div>

              {/* Email Scuole */}
              <div className="bg-white rounded-2xl border border-[#DADCE0] overflow-hidden">
                <div className="bg-[#34A853] px-6 py-3 flex items-center justify-between">
                  <span className="text-white font-medium">🎓 Email Scuole PNRR DM 66</span>
                  <Button
                    size="sm"
                    className={`${copiedEmail === 'scuole' ? 'bg-[#4285F4]' : 'bg-white text-[#34A853]'} rounded-full`}
                    onClick={() => copyToClipboard(emailScuole, 'scuole')}
                  >
                    {copiedEmail === 'scuole' ? <CheckCircle className="w-4 h-4 mr-1" /> : <Copy className="w-4 h-4 mr-1" />}
                    {copiedEmail === 'scuole' ? 'Copiato!' : 'Copia'}
                  </Button>
                </div>
                <pre className="p-6 text-sm text-[#202124] whitespace-pre-wrap font-mono leading-relaxed max-h-96 overflow-y-auto">
                  {emailScuole}
                </pre>
              </div>
            </motion.div>
          )}

          {/* Stats */}
          <motion.div 
            className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <div className="p-4 rounded-2xl bg-[#E8F0FE] text-center">
              <div className="text-2xl font-bold text-[#4285F4]">3 MLD €</div>
              <div className="text-xs text-[#5F6368]">Mercato e-Learning</div>
            </div>
            <div className="p-4 rounded-2xl bg-[#FCE8E6] text-center">
              <div className="text-2xl font-bold text-[#EA4335]">44 MLD €</div>
              <div className="text-xs text-[#5F6368]">Costo Mismatch/anno</div>
            </div>
            <div className="p-4 rounded-2xl bg-[#E6F4EA] text-center">
              <div className="text-2xl font-bold text-[#34A853]">€122/h</div>
              <div className="text-xs text-[#5F6368]">PNRR DM 66</div>
            </div>
            <div className="p-4 rounded-2xl bg-[#FEF7E0] text-center">
              <div className="text-2xl font-bold text-[#FBBC05]">100%</div>
              <div className="text-xs text-[#5F6368]">Deducibile</div>
            </div>
          </motion.div>

          {/* Back */}
          <div className="mt-8 flex flex-wrap gap-4">
            <Button onClick={() => navigate("/agenzie")} variant="outline" className="rounded-full border-[#4285F4] text-[#4285F4]">
              Agenzie Immobiliari
            </Button>
            <Button onClick={() => navigate("/email")} variant="outline" className="rounded-full border-[#EA4335] text-[#EA4335]">
              Email Agenzie
            </Button>
            <Button onClick={() => navigate("/roadmap")} variant="outline" className="rounded-full border-[#34A853] text-[#34A853]">
              Roadmap Commerciale
            </Button>
          </div>

          <div className="mt-6 border-t border-[#DADCE0] pt-4">
            <InternalNav />
          </div>
        </motion.div>
      </div>
    </div>
  );
}
